import { useContext, useState } from "react";
import { AppContext } from "../App";
import { Icon } from "./Icon";
import { t } from "../i18n";

export const PromoBanner = () => {
	const { flow, promos } = useContext(AppContext);
	const [visible, setVisible] = useState(false);

	if (!promos || promos.length === 0) {
		return null;
	}

	// Buscar promo para este flow
	const promoObj = promos.find((item) => item[flow]);
	const promo = promoObj ? promoObj[flow] : null;

	if (!promo) {
		return null; // no hay promo para este flow
	}

	return (
		<>
			<div key={promo.ID} className="feature">
				<div id="kitepane" className="feature-content">
					<div className="feature-title">
						<div className="feature-image">
							<img src={promo.featured_image} alt={promo.title} />
						</div>
						<div className="feature-info">
							<h2>
								<strong>{promo.post_title}</strong>
							</h2>
							<button onPointerDown={() => setVisible(!visible)}>
								<Icon
									name="plus"
									className={`kensei_03 ${
										visible ? "rotate" : ""
									}`}
								/>
								{visible ? (
									<span className="kensei_03">
										{t("Menos info")}
									</span>
								) : (
									<span className="kensei_03">
										{t("Más info")}
									</span>
								)}
							</button>
						</div>
					</div>
					<div
						className={`feature-additional-info kensei_03 ${
							visible ? "visible" : ""
						}`}
					>
						<h4>{promo.description}</h4>
						<p
							dangerouslySetInnerHTML={{
								__html: promo.additional_info,
							}}
						/>
					</div>
				</div>
			</div>
		</>
	);
};
